MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

const observer = new MutationObserver(function (mutations) {
	// Remove default wishlist.
	mutations.forEach(function (mutation) {
		mutation.addedNodes.forEach(function (node) {
			if (!node.parentElement) {
				return;
			}
			if (!node.parentElement.classList.contains('tinvwl_wishlist')) {
				return;
			}
			if (node.nodeName === 'OPTION' && node.textContent === window.tinvwl_add_to_wishlist.text_default_title) {
				let parentNode = node.parentNode;
				parentNode.removeChild(node);
				parentNode.dispatchEvent(new Event('change'));
			}
		});
	});
	// Remove duplicate options.
	document.querySelectorAll('select.tinvwl_wishlist').forEach((select) => {
		const options = [];
		select.querySelectorAll('option').forEach((option) => {
			if (options.includes(option.value)) {
				option.remove();
			}
			else {
				options.push(option.value);
			}
		});
	});
});

const multipleSelectLists = document.querySelectorAll('select.tinvwl_wishlist');

multipleSelectLists.forEach((multipleSelectList) => {
	observer.observe(multipleSelectList, {
		childList: true,
		subtree: true,
		attributes: false,
		characterData: false,
	});
});

const productObserver = new MutationObserver(function (mutations) {
	mutations.forEach(function (mutation) {
		if (mutation.type !== 'attributes') {
			return;
		}
		if (mutation.attributeName !== 'data-tinv-wl-list') {
			return;
		}
		let f = JSON.parse(mutation.target.getAttribute('data-tinv-wl-list'));
		let j = false;
		for (var i in f) {
			if (f[i].title === window.tinvwl_add_to_wishlist.text_default_title) {
				if (f[i].hasOwnProperty('in') && Array.isArray(f[i].in)) {
					j = true;
				}
			}
		}
		if (!j) {
			mutation.target.classList.remove('tinvwl-product-in-list');
			mutation.target.classList.remove('tinvwl-product-make-remove');
			mutation.target.setAttribute('data-tinv-wl-action','addto');
		}
	});
});

const productLists = document.querySelectorAll('ul.products');

productLists.forEach((productList) => {
	productObserver.observe((productList), {
		attributeFilter: ['data-tinv-wl-list'],
		attributes: true,
		subtree: true,
	});
});

(function ($) {
	// Update wishlist automatically on quantity change.
	const delay = 500;
	let timeout;
	const updateForm = $('button.tinvwl-button[value="product_update"]').closest('form');

	function updateQuantity() {
		$.ajax({
			type: updateForm.attr('method'),
			url: updateForm.attr('action'),
			data: updateForm.serialize() + '&tinvwl-action=product_update',
			success: function () {
				updateForm.removeClass('processing').unblock();
			}
		});
	}

	$('.tinv-wishlist .wishlist_item').on('change', 'input.qty', function () {
		if (timeout !== undefined) {
			clearTimeout(timeout);
		}
		timeout = setTimeout(function () {
			// Copied from woocommerce/assets/js/frontend/cart.js file.
			updateForm.addClass('processing').block({
				message: null,
				overlayCSS: {
					background: '#fff',
					opacity: 0.6
				}
			});
			updateQuantity();
		}, delay);
	});

	// Apply styles from Suki WooCommerce cart to wishlish table, instead of overwriting the template.
	$('.tinvwl-table-manage-list').addClass('cart');
})(jQuery);
